import React from 'react'
import icon from '../../../assets/icon/pdf.svg'

const IconPdf = () => {
  return <img src={icon} alt="pdf-download" width="25px" height="25px" />
}

export default IconPdf
